import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate',
  pure: false,
  standalone: true
})
export class CustomDatePipe implements PipeTransform {

  transform(value: any, format: string = 'MMM d, yyyy'): any {
    const date = new Date(value);

    // Check if the input is a valid date
    if (isNaN(date.getTime())) {
      return value; // Return the original value if invalid
    }

    // Format the valid date and return it
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    }).format(date);
  }
}
